// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"73107edb","111":"ee7ec97a","331":"1ce0f8cf"}[chunkId] + ".chunk.js";
};